<template>
  <div class="mb15 mt20 payment-cash-on-delivery-info-container">
    <h4 class="mt0">
      {{ $t('Payment Information') }}
    </h4>
    <div class="bg-cl-secondary px20 py20">
      <p>
        {{ $t('You are going to pay for this order upon delivery.') }}
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CustomPayments',
  data () {
    return {}
  }
}
</script>
